/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuPriceRanges_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterPrice_user$ref: FragmentReference;
export type SbRespRefineMenuFilterPrice_user = {|
  +$fragmentRefs: SbSharedRefineMenuPriceRanges_user$ref,
  +$refType: SbRespRefineMenuFilterPrice_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterPrice_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuPriceRanges_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd5d1849717150a9b7015e0a209e2f85a';
module.exports = node;
